"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsBarMenuButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _Menu = _interopRequireDefault(require("@mui/icons-material/Menu"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/*
 * Description: This component provides a menu button to show/hide a sidebar.
 * Props:
 *   - onClick: Callback function to handle menu button clicks (required).
 */
const DmsBarMenuButton = _ref => {
  let {
    onClick,
    sx,
    sxIcon
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    color: "inherit",
    onClick: onClick,
    sx: sx
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
    sx: sxIcon
  }));
};
exports.DmsBarMenuButton = DmsBarMenuButton;
DmsBarMenuButton.propTypes = {
  onClick: _propTypes.default.func.isRequired
};